import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  IconButton,
  InputAdornment,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

const sampleData = [
  { id: 1, title: "Українська мова 8 клас Авраменко", link: "/class/8/ukrmova/avr/modules" },
  { id: 2, title: "Українська література 8 клас Голуб", link: "/class/8/ukrmova/gol/modules" },
  { id: 3, title: "Українська література 8 клас Авраменко", link: "/class/8/ukrlit/avr/modules" },
  { id: 4, title: "Українська література 8 клас Яценко", link: "/class/8/ukrlit/yac/modules" },
  { id: 5, title: "Українська та зарубіжна література 8 клас Яценко", link: "/class/8/int/yac/modules" },
  { id: 6, title: "Здоров'я, безпека та добробут 8 клас Поліщук", link: "/class/8/zbd/pol/modules" },
  { id: 7, title: "Українська мова та читання 3 клас Захарійчук", link: "/class/3/chutannya/zah/modules" },
  { id: 8, title: "Математика 3 клас Прошкуратова", link: "/class/3/math/prosh/modules" },
  { id: 9, title: "Українська мова 2 клас Захарійчук", link: "/class/2/ukrmova/zah/modules" },
  { id: 10, title: "Математика 2 клас Прошкуратова", link: "/class/2/math/prosh/modules" },
  { id: 11, title: "Математика 1 клас Прошкуратова", link: "/class/1/math/prosh/modules" },
  { id: 12, title: "Буквар 1 клас Захарійчук", link: "/class/1/bukv/zah/modules" },
];

function SearchComponent({ onNavigate }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const navigate = useNavigate();

  const filteredData = useMemo(() => {
    const value = searchTerm.trim().toLowerCase();
    if (!value) {
      return [];
    }

    return sampleData.filter((item) => item.title.toLowerCase().includes(value));
  }, [searchTerm]);

  const navigateTo = (link) => {
    navigate(link);
    setSearchTerm("");
    setIsFocused(false);
    onNavigate?.();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (filteredData.length > 0) {
      navigateTo(filteredData[0].link);
    }
  };

  const showResults = isFocused && searchTerm.trim() !== "";

  return (
    <Box className="app-search">
      <Box component="form" onSubmit={handleSubmit} className="app-search__form">
        <TextField
          fullWidth
          size="small"
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setTimeout(() => setIsFocused(false), 120)}
          placeholder="Пошук..."
          autoComplete="off"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton type="submit" edge="end" aria-label="Шукати">
                  <SearchRoundedIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {showResults && (
        <Paper className="app-search__results" elevation={6}>
          <List dense disablePadding>
            {filteredData.map((item) => (
              <ListItemButton key={item.id} onMouseDown={() => navigateTo(item.link)}>
                <ListItemText primary={item.title} />
              </ListItemButton>
            ))}
            {filteredData.length === 0 && (
              <Typography className="app-search__empty" variant="body2">
                Нічого не знайдено
              </Typography>
            )}
          </List>
        </Paper>
      )}
    </Box>
  );
}

export default SearchComponent;
